import { render, staticRenderFns } from "./SupervisionTender.vue?vue&type=template&id=2d238179&"
import script from "./SupervisionTender.vue?vue&type=script&lang=js&"
export * from "./SupervisionTender.vue?vue&type=script&lang=js&"
import style0 from "./SupervisionTender.vue?vue&type=style&index=0&id=2d238179&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports